import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

import colors from "assets/theme/base/colors";
import borders from "assets/theme/base/borders";
import rgba from "assets/theme/functions/rgba";

const { black, dark, primary } = colors;
const { borderWidth } = borders;

function MultipleChoiceAnalyticsCard({ item }) {
  const options = Array.isArray(item?.options) ? item.options : [];

  return (
    <VuiBox
      p={2}
      borderRadius="18px"
      sx={{
        height: "100%",
        background: rgba(black.main, 0.025),
        border: `${borderWidth[1]} solid ${rgba(black.main, 0.08)}`,
      }}
    >
      <VuiBox
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        gap={2}
        mb={1.5}
      >
        <VuiBox>
          <VuiTypography variant="button" color="dark" fontWeight="bold">
            {item?.question || "Multiple Choice Question"}
          </VuiTypography>

          <VuiTypography
            display="block"
            variant="caption"
            color="dark"
            fontWeight="regular"
            sx={{ opacity: 0.7, mt: 0.3 }}
          >
            Option distribution
          </VuiTypography>
        </VuiBox>

        <VuiBox textAlign="right">
          <VuiTypography variant="button" color="dark" fontWeight="bold">
            {item?.responses || 0}
          </VuiTypography>

          <VuiTypography
            display="block"
            variant="caption"
            color="dark"
            fontWeight="regular"
            sx={{ opacity: 0.7 }}
          >
            responses
          </VuiTypography>
        </VuiBox>
      </VuiBox>

      <VuiBox display="flex" flexDirection="column" gap={1.3}>
        {options.length ? (
          options.map((option) => (
            <VuiBox key={option.label}>
              <VuiBox display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
                <VuiTypography variant="caption" color="dark" fontWeight="medium">
                  {option.label}
                </VuiTypography>

                <VuiTypography variant="caption" color="dark" fontWeight="bold">
                  {option.percentage || 0}%
                </VuiTypography>
              </VuiBox>

              <VuiBox
                width="100%"
                height="7px"
                borderRadius="20px"
                sx={{
                  background: rgba(black.main, 0.08),
                  overflow: "hidden",
                }}
              >
                <VuiBox
                  height="100%"
                  width={`${option.percentage || 0}%`}
                  borderRadius="20px"
                  sx={{
                    background: primary.main,
                  }}
                />
              </VuiBox>

              <VuiTypography
                display="block"
                variant="caption"
                color="dark"
                fontWeight="regular"
                sx={{ opacity: 0.65, mt: 0.4 }}
              >
                {option.count || 0} selections
              </VuiTypography>
            </VuiBox>
          ))
        ) : (
          <VuiBox py={3} textAlign="center">
            <VuiTypography variant="caption" color="dark" fontWeight="medium">
              No option data available.
            </VuiTypography>
          </VuiBox>
        )}
      </VuiBox>
    </VuiBox>
  );
}

export default MultipleChoiceAnalyticsCard;
